<template>
  <div>
    <div class="row">
      <div class="col-6 mt-4">
        <div class="row">
          <div class="col-12">
            <idx-card
              :title="`${this.$t('menu.masterSettings.titleNewUser')}`"
              icon="user"
            >
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <label for="user-profile"
                        >{{
                          this.$t('menu.masterSettings.labels.company')
                        }}:</label
                      >
                      <b-form-select
                        v-model="user.company"
                        :options="allCompanies"
                      >
                      </b-form-select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-3">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t('menu.masterSettings.labels.name')
                          }}:</label
                        >
                        <input
                          type="text"
                          v-model="user.name"
                          id="user-name"
                          class="form-control"
                          :placeholder="`${this.$t(
                            'menu.masterSettings.placeholderUserName',
                          )}`"
                          @keyup="removeInvalidClass('user-name')"
                        />
                        <div class="invalid-feedback">
                          {{
                            this.$t(
                              'menu.masterSettings.feedbackInformNameUser',
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t('menu.masterSettings.labels.email')
                          }}:</label
                        >
                        <input
                          type="email"
                          v-model="user.email"
                          id="user-email"
                          class="form-control"
                          :placeholder="`${this.$t(
                            'menu.masterSettings.placeholderEmail',
                          )}`"
                          @keyup="removeInvalidClass('user-email')"
                        />
                        <div class="invalid-feedback">
                          {{
                            this.$t('menu.masterSettings.feedbackInformEmail')
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t('menu.masterSettings.labels.phone')
                          }}:</label
                        >
                        <input
                          type="text"
                          v-model="user.phone"
                          id="user-phone"
                          class="form-control"
                          :placeholder="`${this.$t(
                            'menu.masterSettings.placeholderPhone',
                          )}`"
                          @keyup="removeInvalidClass('user-phone')"
                          v-mask="'+## (##) #####-####'"
                        />
                        <div class="invalid-feedback">
                          {{
                            this.$t('menu.masterSettings.feedbackInformPhone')
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t('menu.masterSettings.labels.post')
                          }}:</label
                        >
                        <input
                          type="text"
                          v-model="user.position"
                          id="user-position"
                          class="form-control"
                          :placeholder="`${this.$t(
                            'menu.masterSettings.placeholderPostUser',
                          )}`"
                          @keyup="removeInvalidClass('user-position')"
                        />
                        <div class="invalid-feedback">
                          {{
                            this.$t('menu.masterSettings.feedbackInformPost')
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-6">
                      <label for="user-profile"
                        >{{
                          this.$t('menu.masterSettings.labels.profile')
                        }}:</label
                      >
                      <b-form-select
                        v-model="user.profile"
                        :options="user.options"
                      >
                      </b-form-select>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t('menu.masterSettings.labels.passwordUser')
                          }}:</label
                        >
                        <input
                          type="password"
                          v-model="user.password1"
                          id="user-password1"
                          @input="checkPassword"
                          class="form-control"
                          :placeholder="`${this.$t(
                            'menu.masterSettings.placeholderPassword',
                          )}`"
                          @keyup="removeInvalidClass('user-password1')"
                        />
                        <ul>
                          <span class="invalid-feedback">
                            <li>
                              {{
                                $t(
                                  'menu.settings.users.invalidFeedbackSamePass',
                                )
                              }}
                            </li>
                          </span>
                          <span v-if="!contains_eight_characters">
                            <li class="invalid-password-user">
                              {{
                                $t(
                                  'menu.settings.users.messages.eightCharacters',
                                )
                              }}
                            </li></span
                          >
                          <span v-if="!contains_number"
                            ><li class="invalid-password-user">
                              {{
                                $t(
                                  'menu.settings.users.messages.containNumbers',
                                )
                              }}
                            </li>
                          </span>
                          <span v-if="!contains_uppercase"
                            ><li class="invalid-password-user">
                              {{
                                $t(
                                  'menu.settings.users.messages.containCapitalLetters',
                                )
                              }}
                            </li>
                          </span>
                          <span v-if="!contains_special_character">
                            <li class="invalid-password-user">
                              {{
                                $t(
                                  'menu.settings.users.messages.containSpecialCharacters',
                                )
                              }}
                            </li>
                          </span>
                        </ul>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="user-name"
                          >{{
                            this.$t(
                              'menu.masterSettings.labels.repeatPassword',
                            )
                          }}:</label
                        >
                        <input
                          type="password"
                          v-model="user.password2"
                          id="user-password2"
                          class="form-control"
                          placeholder="Senha do usuário"
                          @keyup="removeInvalidClass('user-password2')"
                        />
                        <div class="invalid-feedback">
                          {{ this.$t('menu.masterSettings.feedbackSamePass') }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 button-area">
                      <button @click="sendNewUser" class="btn btn-primary">
                        {{ this.$t('menu.masterSettings.buttonRegister') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </idx-card>
          </div>
        </div>
      </div>
      <div class="col-6 mt-4">
        <div class="row">
          <div class="col-7">
            <div class="search-users">
              <input
                type="text"
                class="form-control"
                id="input-users"
                :placeholder="`${this.$t(
                  'menu.masterSettings.placeholderSearch',
                )}`"
                v-model="filter"
                @keyup="searchUsers"
              />

              <button
                class="btn btn-outline-primary"
                :title="`${this.$t('menu.masterSettings.clear')}`"
                @click="cleanFilter"
              >
                {{ this.$t('menu.masterSettings.clear') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <b-table
              striped
              :items="myUsers.users"
              :fields="fields"
              :busy="loading"
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
              </template>
              <template v-slot:cell(company)="row">
                {{ row.item.companyId.name || 'Nenhuma' }}
                {{ hasCompanyList(row.item._id) }}
              </template>
              <template v-slot:cell(lastLogin)="row">
                {{ row.item.lastLogin ? dateFormat(row.item.lastLogin) : '-' }}
              </template>
              <template v-slot:cell(options)="row">
                <div class="buttons-area" style="min-width: 90px;">
                  <button
                    v-b-modal="`edit-user-${row.item._id}`"
                    class="btn btn-outline-primary"
                  >
                    <font-awesome-icon :icon="['fas', 'pen']" />
                  </button>
                  <button
                    class="btn btn-outline-danger"
                    @click="removeUser(row.item._id, row.item.name)"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-alt']" />
                  </button>
                </div>
                <modal-edit-user-master
                  :id="row.item._id"
                  :myUser="row.item"
                  :page="page"
                  :filter="filter"
                />
              </template>
            </b-table>
            <div
              v-if="myUsers.users.length === 0 && loading === false"
              class="mb-3"
            >
              <span>
                {{ this.$t('menu.masterSettings.noUserRegistered') }}</span
              >
            </div>
            <div v-show="!loading" class="pagination-area-config-users">
              <paginate
                v-model="page"
                :pageCount="Math.ceil(myUsers.total / 5)"
                :clickHandler="changePage"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              >
              </paginate>
            </div>
            <div class="col-12 text-right">
              <div class="loader">
                <b-spinner
                  v-if="loadingPdf"
                  class="spinner-border"
                  label="Spinning"
                ></b-spinner>

                <a @click="exportToXLS" title="Exportar para XLS">
                  <span class="xls">
                    <i class="fas fa-file-excel"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import XLSX from 'xlsx';
import { lightFormat } from 'date-fns';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import ModalEditUserMaster from '../modal-edit-user';

export default {
  components: { ModalEditUserMaster, Paginate, IdxCard },
  data: () => ({
    userAuth: null,
    filter: null,
    typingTimer: null,
    user: {
      name: null,
      email: null,
      formattedPhone: null,
      phone: null,
      position: null,
      password1: null,
      password2: null,
      profile: 'analyst',
      company: '0',
      options: [],
    },
    loading: true,
    fields: [],
    page: 1,
    password_length: 0,
    contains_eight_characters: true,
    contains_number: true,
    contains_uppercase: true,
    contains_special_character: true,
    valid_password: true,
    loadingPdf: false,
  }),
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.updateTableMaster();
    await this.getAllCompanies({ token: this.userAuth.token, justIds: true });
    this.user.options = [
      { value: 'master', text: this.$t('menu.masterSettings.master') },
      { value: 'admin', text: this.$t('menu.masterSettings.admin') },
      { value: 'analyst', text: this.$t('menu.masterSettings.analyst') },
      { value: 'admin-access', text: this.$t('menu.masterSettings.adminAccess') },
    ];
    this.fields = [
      { key: 'name', label: this.$t('menu.masterSettings.labels.user') },
      { key: 'occupation', label: this.$t('menu.masterSettings.labels.post') },
      { key: 'company', label: this.$t('menu.masterSettings.labels.company') },
      {
        key: 'lastLogin',
        label: this.$t('menu.masterSettings.labels.lastAcess'),
      },
      { key: 'options', label: this.$t('menu.masterSettings.labels.options') },
    ];
  },
  computed: {
    ...mapState('master', ['myUsers', 'allCompanies']),
  },
  methods: {
    ...mapActions('settings', ['registerUser', 'deleteUser']),
    ...mapActions('master', ['getUsersMaster', 'getAllCompanies']),

    async exportToXLS() {
      const header = [
        'Nome',
        'Cargo',
        'Email',
        'Empresa',
        'Último Acesso',
        'Perfil',
      ];

      const arr = [];

      this.loadingPdf = true;

      this.myUsers.usersExcel.forEach((el) => {
        arr.push({
          Nome: el.name,
          Cargo: el.occupation,
          Empresa: el.companyList
            ? el.companyList.toString()
            : el.companyId.name,
          Email: el.email,
          'Último Acesso': el.lastLogin,
          Perfil: el.profileId ? el.profileId.type : '-',
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('usuarios');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      wb.Sheets.usuarios = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'usuarios.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);

      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;

      this.loadingPdf = false;

      return buf;
    },

    async updateTableMaster() {
      this.loading = true;
      await this.getUsersMaster({
        token: this.userAuth.token,
        page: this.page,
        limit: '5',
        filter: this.filter,
      });
      this.loading = false;
    },
    searchUsers() {
      if (this.filter) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTableMaster, 600);
      } else if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTableMaster, 600);
      }
    },
    cleanFilter() {
      if (this.filter) {
        this.filter = null;
        this.page = 1;
        this.updateTableMaster();
      }
    },
    changePage() {
      this.updateTableMaster();
    },
    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'H:mm');
      return `${day} às ${hour}`;
    },
    sendNewUser() {
      if (this.validateFields()) {
        this.registerUser({
          token: this.userAuth.token,
          companyId: this.user.company,
          user: {
            name: this.user.name,
            email: this.user.email,
            password: this.user.password2,
            type: this.user.profile,
            occupation: this.user.position,
            celPhone: this.formattedPhone,
            profileType: this.user.profile,
            createdBy: this.userAuth._id,
            updatedBy: this.userAuth._id,
          },
        })
          .then(() => {
            this.user.name = null;
            this.user.email = null;
            this.user.phone = null;
            this.user.position = null;
            this.user.profile = 'analyst';
            this.user.password1 = null;
            this.user.password2 = null;
            this.user.company = '0';
            this.loading = true;
            this.updateTableMaster();
            swal({
              title: this.$t(
                'menu.masterSettings.messages.successAddUser.title',
              ),
              text: this.$t(
                'menu.masterSettings.messages.successAddUser.description',
              ),
              icon: 'success',
            });
          })
          .catch((error) => {
            swal({
              title: this.$t('menu.masterSettings.ops'),
              text: `${error.response.data.message}`,
              icon: 'warning',
            });
          });
      }
    },
    validateFields() {
      if (this.user.company === '0') {
        swal({
          title: this.$t('menu.masterSettings.messages.selectCompany.title'),
          text: this.$t(
            'menu.masterSettings.messages.selectCompany.description',
          ),
          icon: 'warning',
        });
        return false;
      } else if (!this.user.name) {
        document.getElementById('user-name').classList.add('is-invalid');
        return false;
      } else if (!this.user.email) {
        document.getElementById('user-email').classList.add('is-invalid');
        return false;
        // } else if (!this.user.phone) {
        //   document.getElementById('user-phone').classList.add('is-invalid');
        //   return false;
      } else if (!this.user.position) {
        document.getElementById('user-position').classList.add('is-invalid');
        return false;
      } else if (!this.user.password1) {
        document.getElementById('user-password1').classList.add('is-invalid');
        return false;
      } else if (
        !this.user.password2 ||
        this.user.password1 !== this.user.password2
      ) {
        document.getElementById('user-password2').classList.add('is-invalid');
        return false;
      }
      // if (!this.formatNumber()) {
      //   return false;
      // }
      if (this.user.profile === 'master' && this.user.company !== 'IndeCX') {
        swal({
          title: this.$t('menu.masterSettings.messages.userMaster.title'),
          text: this.$t('menu.masterSettings.messages.userMaster.description'),
          icon: 'warning',
        });
        return false;
      }
      return true;
    },
    // formatNumber() {
    //   this.formattedPhone = '';
    //   for (let i = 0; i <= this.user.phone.length; i += 1) {
    //     if (
    //       parseInt(this.user.phone.charAt(i), 10) ||
    //       this.user.phone.charAt(i) === '0'
    //     ) {
    //       this.formattedPhone += this.user.phone.charAt(i);
    //     }
    //   }
    //   if (
    //     !parseInt(this.formattedPhone, 10) &&
    //     this.formattedPhone.length !== 13
    //   ) {
    //     document.getElementById('user-phone').classList.add('is-invalid');
    //     return false;
    //   }
    //   return true;
    // },
    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },
    removeUser(id, name) {
      swal({
        title: this.$t('menu.masterSettings.messages.removeUser.title'),
        text: this.$t('menu.masterSettings.messages.removeUser.description', {
          nameUser: `${name}`,
        }),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          this.deleteUser({
            token: this.userAuth.token,
            loggedUser: this.userAuth._id,
            userId: id,
          }).then(() => {
            this.updateTableMaster();
          });
        }
      });
    },
    checkPassword() {
      this.password_length = this.user.password1.length;
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }
      this.contains_number = /\d/.test(this.user.password1);
      this.contains_uppercase = /[A-Z]/.test(this.user.password1);
      this.contains_special_character = format.test(this.user.password1);
      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    hasCompanyList(userId) {
      for (let i = 0; i < this.myUsers.users.length; i += 1) {
        if (this.myUsers.users[i]._id === userId) {
          if (
            this.myUsers.users[i].companyList &&
            this.myUsers.users[i].companyList.length > 1
          ) {
            return ' +';
          }
        }
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.spinner-border {
  color: #4ce595;
  width: 1.5rem;
  height: 1.5rem;
}

.loader {
  background-color: #fff;
  display: block;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.button-area {
  display: flex;
  justify-content: flex-end;
  button {
    align-self: flex-end;
  }
}
.search-users {
  display: flex;
  flex-direction: row;
  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
.screen {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}
.header {
  background-color: #72bcd4;
  color: #fff;
  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.body {
  padding: 20px;
  border: 1px solid #ccc;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.pagination-area-config-users >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-config-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-config-users a {
  outline: none;
}
.invalid-password-user {
  font-size: 80%;
  color: #d50000;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/master/master-users/index.vue